import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  BookOpen,
  Building2,
  Palette,
  ShieldCheck,
  Users,
} from 'lucide-react';
import { routeConstants } from '../../../constants/routeConstants';

const items = [
  {
    path: routeConstants.SETTINGS_PROFILE,
    label: 'School Profile',
    description: 'Identity and contact details',
    icon: Building2,
  },
  {
    path: routeConstants.SETTINGS_BRANDING,
    label: 'Branding',
    description: 'Logo, seal and document branding',
    icon: Palette,
  },
  {
    path: routeConstants.SETTINGS_ACADEMICS,
    label: 'Academic Setup',
    description: 'Years, classes, sections and subjects',
    icon: BookOpen,
  },
  {
    path: routeConstants.SETTINGS_USERS,
    label: 'Users & Access',
    description: 'Accounts and assigned roles',
    icon: Users,
  },
  {
    path: routeConstants.SETTINGS_ROLES,
    label: 'Roles & Permissions',
    description: 'Roles and permission assignments',
    icon: ShieldCheck,
  },
];

const SettingsNavigation = () => (
  <nav className="space-y-1 p-3" aria-label="Settings navigation">
    {items.map((item) => {
      const Icon = item.icon;
      return (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `flex items-start gap-3 rounded-xl px-3 py-3 transition-colors ${
              isActive
                ? 'bg-blue-50 text-blue-700'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`
          }
        >
          <Icon className="mt-0.5 h-5 w-5 shrink-0" />
          <span>
            <span className="block text-sm font-semibold">{item.label}</span>
            <span className="mt-0.5 block text-xs text-gray-500">
              {item.description}
            </span>
          </span>
        </NavLink>
      );
    })}
  </nav>
);

export default SettingsNavigation;
